import React from 'react';
import {
  Heading1,
  Paragraph,
  LinkStyled,
} from '../components/typography';
import { Image } from '../components/Image';
import { Container, Row, Col } from '../components/grid';
import PlastOverPap from '../components/PlastOverPap';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="PlastPap">
    <Container white>
      <Row>
        <Col xs={12} md={8}>
          <Heading1>Miljø: Plastflasker er bedre end pap/karton emballage</Heading1>
          <Paragraph fontSize="16px">
            Plastflasker med pant har et meget lavere klimaaftryk end papkartoner, bekræfter en LCA-screening udført af DTU Environment for Bryggeriforeningen.
            Dette skyldes hovedsageligt, at 93% af plastflaskerne indsamles og genanvendes via pantsystemet.
            Derimod havner papkartoner i stedet som affald til forbrænding.
          </Paragraph>
          <Paragraph fontSize="16px">
            En let plastflaske af 50% rPET, på 50cl som vejer 14,2 gram med låg, har et klimaaftryk, der er 64% lavere end en papkarton på 50cl.
          </Paragraph>
          <Paragraph>
            <LinkStyled external to="/pdf/egekilde-dokumenteret-baeredygtighed.pdf">Læs mere om bæredygtighed af plastikflasker her (pdf)</LinkStyled>
          </Paragraph>
        </Col>
        <Col xs={12} md={4} textCenter>
          <Image name="oel-vand.plast-pap.png" alt="Plastflaske og papkarton" imageHeight="200px" maxHeight="200px" />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6} md={4} lg={2}>
          <PlastOverPap
            title="Genanvendelse"
            indikator="%"
            flaskeProcent="93"
            kartonProcent="0"
            flaskeWhite
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <PlastOverPap
            title="Plast"
            indikator="g"
            flaskeProcent="20"
            kartonProcent="8"
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <PlastOverPap
            title="Aluminium"
            indikator="g"
            flaskeProcent="0"
            kartonProcent="1.3"
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <PlastOverPap
            title="Pap"
            indikator="g"
            flaskeProcent="0"
            kartonProcent="14.4"
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <PlastOverPap
            title="Vægt"
            indikator="g"
            flaskeProcent="20"
            kartonProcent="23.7"
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <PlastOverPap
            title="Forbrænding"
            indikator="%"
            flaskeProcent="7"
            kartonProcent="100"
            kartonWhite
          />
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
